<template>
  <d-modal @close="handleClose">
    <d-modal-header>
      <d-modal-title>
        {{ $t('customer.discount.modifyCustomerDiscounts') }} - {{ selectedCustomer.name }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <d-form :style="saveInProgress ? 'opacity: .25; pointer-events: none;' : ''">
        <validation-observer ref="customer-discounts-form" tag="form">
          <div class="form-group">
            <label>
              {{ $t('customer.discount.productDiscount') }}:
            </label>

            <validation-provider
              rules="required|min:0|max:100"
              name="discount_products"
              v-slot="{ errors }">
              <d-input-group
                prepend="%"
                :class="{'mb-2': true, 'is-invalid': errors.length}">
                <input
                  :class="{
                    'form-control': true,
                    'is-invalid': errors.length
                  }"
                  :invalid="errors.length ? true : null"
                  :min="0"
                  :step="0.01"
                  type="number"
                  v-model="discountProducts" />
                <d-input-group-text slot="append">%</d-input-group-text>
              </d-input-group>
              <d-form-invalid-feedback>
                {{ errors[0] }}
              </d-form-invalid-feedback>
            </validation-provider>
          </div>

          <div class="form-group">
            <label>
              {{ $t('customer.discount.serviceDiscount') }}:
            </label>

            <validation-provider
              rules="required|min:0|max:100"
              name="discount_services"
              v-slot="{ errors }">
              <d-input-group
                prepend="%"
                :class="{'mb-2': true, 'is-invalid': errors.length}">
                <input
                  :class="{
                    'form-control': true,
                    'is-invalid': errors.length
                  }"
                  :invalid="errors.length ? true : null"
                  :min="0"
                  :step="0.01"
                  type="number"
                  v-model="discountServices" />
                <d-input-group-text slot="append">%</d-input-group-text>
              </d-input-group>
              <d-form-invalid-feedback>
                {{ errors[0] }}
              </d-form-invalid-feedback>
            </validation-provider>
          </div>

          <div class="form-group">
            <label>
              {{ $t('customer.discount.shippingDiscount') }}:
            </label>

            <validation-provider
              rules="required|min:0|max:100"
              name="discount_shipping"
              v-slot="{ errors }">
              <d-input-group
                prepend="%"
                :class="{'mb-2': true, 'is-invalid': errors.length}">
                <input
                  :class="{
                    'form-control': true,
                    'is-invalid': errors.length
                  }"
                  :invalid="errors.length ? true : null"
                  :min="0"
                  :step="0.01"
                  type="number"
                  v-model="discountShipping" />
                <d-input-group-text slot="append">%</d-input-group-text>
              </d-input-group>
              <d-form-invalid-feedback>
                {{ errors[0] }}
              </d-form-invalid-feedback>
            </validation-provider>
          </div>
        </validation-observer>
      </d-form>
    </d-modal-body>
    <d-modal-footer>
      <d-button
        class="ml-0"
        theme="danger"
        @click.prevent="cancel">
        {{ $t('ui.cancel') }}
      </d-button>
      <d-button
        :disabled="saveInProgress"
        class="ml-auto"
        theme="success"
        @click.prevent="validateForm">
        <div
          v-if="saveInProgress"
          class="spinner-border spinner-border-sm"
          role="status"></div>
        <template v-if="!saveInProgress">{{ $t('ui.saveChanges') }}</template>
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'customer-discounts-popup',
  props: [
    'selectedCustomer'
  ],
  data () {
    return {
      discountProducts: 0,
      discountServices: 0,
      discountShipping: 0,
      saveInProgress: false
    };
  },
  mounted () {
    this.discountProducts = this.selectedCustomer.discount_products;
    this.discountServices = this.selectedCustomer.discount_services;
    this.discountShipping = this.selectedCustomer.discount_shipping;
  },
  methods: {
    handleClose () {
      this.$bus.$emit('close-customer-discounts-popup');
    },
    validateForm () {
      FormUtils.validate(this.$refs['customer-discounts-form'], this.submitForm);
    },
    submitForm () {
      this.saveInProgress = true;

      FormUtils.submitInBackground({
        $http: this.$http,
        endpoint: '/customers/update-discounts/' + parseInt(this.selectedCustomer.id, 10),
        formData: {
          discount_products: this.discountProducts.toString().replace(',', '.'),
          discount_services: this.discountServices.toString().replace(',', '.'),
          discount_shipping: this.discountShipping.toString().replace(',', '.')
        },
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('customer.discount.discountsUpdateErrorText'),
        successAction: () => {
          this.saveInProgress = false;
          this.$bus.$emit('order-select-customer-reload-customers-list');
          this.handleClose();
        },
        failAction: () => {
          this.saveInProgress = false;
          this.$bus.$emit('order-select-customer-reload-customers-list');
          this.handleClose();
        }
      });
    },
    cancel () {
      this.handleClose();
    }
  }
}
</script>
